import { render, staticRenderFns } from "./WritingPhonicsForm.vue?vue&type=template&id=e4fe0448&"
import script from "./WritingPhonicsForm.vue?vue&type=script&lang=js&"
export * from "./WritingPhonicsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports